import { render, staticRenderFns } from "./TheStatus.vue?vue&type=template&id=630169f8&scoped=true"
import script from "./TheStatus.vue?vue&type=script&lang=ts"
export * from "./TheStatus.vue?vue&type=script&lang=ts"
import style0 from "./TheStatus.vue?vue&type=style&index=0&id=630169f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630169f8",
  null
  
)

export default component.exports